
const regions = [
  {
    name: '亚太地区',
    description: '中国、新加坡、香港、日本等主要枢纽',
  },
  {
    name: '欧洲',
    description: '覆盖英国、德国、法国、荷兰等地',
  },
  {
    name: '美洲',
    description: '美国、加拿大、墨西哥、巴西等地强势布局',
  },
  {
    name: '中东',
    description: '阿联酋、沙特阿拉伯、卡塔尔等地运营',
  },
];

export default function NetworkSection() {
  return (
    <section id="network" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            <strong>全球网络</strong>覆盖
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            遍布全球的战略合作伙伴和办事处，确保物流运营无缝衔接
          </p>
        </div>
        <div className="grid md:grid-cols-4 gap-8">
          {regions.map((region) => (
            <div key={region.name} className="bg-white rounded-lg p-6 text-center shadow-md hover:shadow-lg transition-shadow cursor-pointer">
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-2xl text-teal-600"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">
                <a href="#network" className="hover:text-teal-600 transition-colors">{region.name}</a>
              </h4>
              <p className="text-sm text-gray-600">{region.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
